<template>
  <div v-if="hasReservation" class="reservation-info" :class="!compact && 'mt-1'">
    <!-- Rezervasyon Badge -->
   <!-- <div
      @click="!compact && showReservationDetails"
      :class="[
        compact ? 'px-1.5 py-0.5 text-xxs' : 'px-2 py-1 text-xs',
        'rounded-full font-medium inline-flex items-center gap-1 transition-all duration-200',
        !compact && 'cursor-pointer hover:scale-105',
        getBadgeClass()
      ]"
      :title="getTooltipText()"
    >
      <i class="fas fa-clock" :class="compact && 'text-xxs'"></i>
      <span>{{ getReservationText() }}</span>
      <span v-if="vehicle.reservationCount > 1 && !compact" class="ml-1 bg-white bg-opacity-30 px-1.5 py-0.5 rounded-full text-xxs">
        +{{ vehicle.reservationCount - 1 }}
      </span>
    </div>
    -->

    <!-- Detaylı Rezervasyon Listesi (Tooltip) - Sadece compact değilse -->
    <div
      v-if="showDetails && !compact"
      @click.stop
      class="absolute left-0 top-full mt-1 bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 p-3 z-50 min-w-[300px]"
    >
      <div class="flex justify-between items-center mb-2 pb-2 border-b border-gray-200 dark:border-gray-700">
        <h4 class="font-semibold text-sm">Rezervasyonlar ({{ vehicle.reservationCount }})</h4>
        <button @click="showDetails = false" class="text-gray-400 hover:text-gray-600">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="space-y-2 max-h-64 overflow-y-auto">
        <div
          v-for="(reservation, index) in vehicle.allReservations"
          :key="index"
          class="p-2 rounded bg-gray-50 dark:bg-gray-700 text-xs"
        >
          <div class="flex items-center justify-between mb-1">
            <span class="font-semibold text-blue-600 dark:text-blue-400">
              {{ reservation.orderNo }}
            </span>
            <span
              class="px-2 py-0.5 rounded-full text-xxs font-medium"
              :class="getModuleBadgeClass(reservation.moduleType)"
            >
              {{ getModuleName(reservation.moduleType) }}
            </span>
          </div>

          <div class="text-gray-600 dark:text-gray-300 space-y-0.5">
            <div class="flex items-center gap-1">
              <i class="fas fa-calendar text-xxs"></i>
              <span>{{ formatDateTime(reservation.scheduledTime) }}</span>
            </div>
            <div class="flex items-center gap-1 text-xxs text-gray-500 dark:text-gray-400">
              <i class="fas fa-arrow-right"></i>
              <span>{{ formatDateTime(reservation.estimatedEndTime) }}</span>
            </div>
          </div>

          <!-- Zaman Kalan Göstergesi -->
          <div v-if="index === 0" class="mt-2 pt-2 border-t border-gray-200 dark:border-gray-600">
            <div class="flex items-center gap-1 text-xxs">
              <i class="fas fa-hourglass-half text-orange-500"></i>
              <span class="text-gray-600 dark:text-gray-300">
                {{ getTimeRemaining(reservation.scheduledTime) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: 'ReservationBadge',
  props: {
    vehicle: {
      type: Object,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDetails: false
    };
  },
  computed: {
    hasReservation() {
      return this.vehicle.hasReservation && this.vehicle.allReservations?.length > 0;
    },

    nextReservation() {
      // Eğer vehicle.nextReservation varsa onu kullan
      if (this.vehicle.nextReservation) {
        return this.vehicle.nextReservation;
      }

      // Yoksa allReservations'dan en yakın olanı bul
      if (!this.vehicle.allReservations || this.vehicle.allReservations.length === 0) {
        console.log('ReservationBadge: allReservations boş', this.vehicle.vehicle);
        return null;
      }

      const now = moment();

      // scheduledTime'a göre sırala ve gelecekteki en yakın olanı al
      const futureReservations = this.vehicle.allReservations
        .filter(r => {
          if (!r.scheduledTime) return false;
          const cleaned = this.cleanDateTime(r.scheduledTime);
          const m = moment(cleaned, 'YYYY-MM-DD HH:mm:ss');
          return m.isValid() && m.isAfter(now);
        })
        .sort((a, b) => {
          const cleanedA = this.cleanDateTime(a.scheduledTime);
          const cleanedB = this.cleanDateTime(b.scheduledTime);
          return moment(cleanedA, 'YYYY-MM-DD HH:mm:ss').diff(moment(cleanedB, 'YYYY-MM-DD HH:mm:ss'));
        });

      if (futureReservations.length > 0) {
        console.log('ReservationBadge: Gelecek rezervasyon bulundu', this.vehicle.vehicle, futureReservations[0]);
        return futureReservations[0];
      }

      // Gelecekte rezervasyon yoksa, en yakın olanı göster (geçmiş de olabilir)
      const sortedReservations = this.vehicle.allReservations
        .filter(r => {
          if (!r.scheduledTime) return false;
          const cleaned = this.cleanDateTime(r.scheduledTime);
          return moment(cleaned, 'YYYY-MM-DD HH:mm:ss').isValid();
        })
        .sort((a, b) => {
          const cleanedA = this.cleanDateTime(a.scheduledTime);
          const cleanedB = this.cleanDateTime(b.scheduledTime);
          return moment(cleanedA, 'YYYY-MM-DD HH:mm:ss').diff(moment(cleanedB, 'YYYY-MM-DD HH:mm:ss'));
        });

      console.log('ReservationBadge: En yakın rezervasyon (geçmiş olabilir)', this.vehicle.vehicle, sortedReservations[0]);
      return sortedReservations[0] || null;
    }
  },
  methods: {
    // Backend'den gelen bozuk tarih formatını düzelt
    cleanDateTime(dateTime) {
      if (!dateTime) return dateTime;
      if (typeof dateTime !== 'string') return dateTime;

      // "2025-10-22T14:51 00:00:00" -> "2025-10-22 14:51:00"
      if (dateTime.includes('T')) {
        // Boşluktan önceki kısmı al (YYYY-MM-DDTHH:mm)
        const parts = dateTime.split(' ')[0];
        // T'yi boşlukla değiştir ve saniye ekle
        return parts.replace('T', ' ') + ':00';
      }

      return dateTime;
    },

    showReservationDetails() {
      this.showDetails = !this.showDetails;
    },

    getBadgeClass() {
      if (!this.nextReservation || !this.nextReservation.scheduledTime) {
        return 'bg-gray-400 text-white';
      }

      const cleanedTime = this.cleanDateTime(this.nextReservation.scheduledTime);
      const scheduledMoment = moment(cleanedTime, 'YYYY-MM-DD HH:mm:ss');

      if (!scheduledMoment.isValid()) {
        return 'bg-gray-400 text-white';
      }

      const hoursUntil = scheduledMoment.diff(moment(), 'hours');

      if (hoursUntil < 2) {
        return 'bg-red-500 text-white animate-pulse';
      } else if (hoursUntil < 6) {
        return 'bg-orange-500 text-white';
      } else {
        return 'bg-blue-500 text-white';
      }
    },

    getReservationText() {
      if (!this.nextReservation) {
        return 'Rezerveli';
      }

      if (!this.nextReservation.scheduledTime) {
        return 'Rezerveli';
      }

      const cleanedTime = this.cleanDateTime(this.nextReservation.scheduledTime);
      const scheduledMoment = moment(cleanedTime, 'YYYY-MM-DD HH:mm:ss');

      if (!scheduledMoment.isValid()) {
        console.log('ReservationBadge: Invalid date', this.vehicle.vehicle, 'Original:', this.nextReservation.scheduledTime, 'Cleaned:', cleanedTime);
        return 'Rezerveli';
      }

      // Compact modda çok kısa format (bugün ise sadece saat, değilse tarih+saat)
      if (this.compact) {
        const isToday = scheduledMoment.isSame(moment(), 'day');
        const isTomorrow = scheduledMoment.isSame(moment().add(1, 'day'), 'day');

        if (isToday) {
          return scheduledMoment.format('HH:mm');
        } else if (isTomorrow) {
          return 'Yarın ' + scheduledMoment.format('HH:mm');
        } else {
          return scheduledMoment.format('DD.MM');
        }
      }

      // Normal modda tam format
      return scheduledMoment.format('DD.MM HH:mm');
    },

    getTooltipText() {
      if (!this.nextReservation) {
        return 'Rezervasyon var';
      }

      const orderNo = this.nextReservation.orderNo || 'N/A';
      const moduleName = this.getModuleName(this.nextReservation.moduleType);
      return `${orderNo} - ${moduleName}`;
    },

    getModuleName(moduleType) {
      const modules = {
        'bulkPlanning': 'Toplu Planlama',
        'planning': 'Planlama',
        'orders': 'Siparişler'
      };
      return modules[moduleType] || moduleType;
    },

    getModuleBadgeClass(moduleType) {
      const classes = {
        'bulkPlanning': 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300',
        'planning': 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300',
        'orders': 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300'
      };
      return classes[moduleType] || 'bg-gray-100 text-gray-700';
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '-';

      const cleanedTime = this.cleanDateTime(dateTime);
      const dateMoment = moment(cleanedTime, 'YYYY-MM-DD HH:mm:ss');

      if (!dateMoment.isValid()) {
        return '-';
      }

      return dateMoment.format('DD.MM.YYYY HH:mm');
    },

    getTimeRemaining(scheduledTime) {
      if (!scheduledTime) return '-';

      const cleanedTime = this.cleanDateTime(scheduledTime);
      const now = moment();
      const scheduled = moment(cleanedTime, 'YYYY-MM-DD HH:mm:ss');

      if (!scheduled.isValid()) {
        return 'Geçersiz tarih';
      }

      const duration = moment.duration(scheduled.diff(now));

      if (duration.asMinutes() < 0) {
        return 'Zaman geçti';
      }

      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();

      if (days > 0) {
        return `${days} gün ${hours} saat kaldı`;
      } else if (hours > 0) {
        return `${hours} saat ${minutes} dakika kaldı`;
      } else {
        return `${minutes} dakika kaldı`;
      }
    }
  },
  mounted() {
    // Dışarı tıklanınca kapat
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
};
</script>

<style scoped>
.reservation-info {
  position: relative;
}

.text-xxs {
  font-size: 0.65rem;
}

/* Animasyon */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Scrollbar styling */
.overflow-y-auto::-webkit-scrollbar {
  width: 4px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
